import styled from "styled-components"
import CustomerCard, { CustomerCardProps } from "./CustomerCard"
import { theme } from "@/common/Mixin"
import React from "react"

export interface CustomerCardListProps {
  style?: React.CSSProperties
  cardStyle?: React.CSSProperties
  items: CustomerCardProps[]
  className?: string
  animation?: boolean
  infiniteScroll?: boolean
}

export default function CustomerCardList({
  style,
  cardStyle,
  items,
  className,
  animation = true,
  infiniteScroll = true
}: CustomerCardListProps) {
  return (
    <Wrapper animation={animation} style={style} className={className}>
      {items.map((item, index) => (
        <CustomerCard
          style={cardStyle}
          key={`${item.company}_${index}`}
          {...item}
        />
      ))}
      {infiniteScroll &&
        items.map((item, index) => (
          <CustomerCard
            style={cardStyle}
            key={`${item.company}_${index}`}
            {...item}
          />
        ))}
    </Wrapper>
  )
}

const Wrapper = styled.div<{ animation: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 24px;

  @keyframes moveY {
    0% {
      transform: translateY(50%);
    }
    100% {
      transform: translateY(0%);
    }
  }

  @keyframes moveY2 {
    0% {
      transform: translateY(0%);
    }
    100% {
      transform: translateY(50%);
    }
  }

  &.line2 {
    animation: moveY2 50s linear infinite;
  }

  &.line3 {
  }

  ${({ animation }) =>
    animation
      ? `
    animation: moveY 50s linear infinite;
    align-self: end;
  `
      : `
    animation: none;
  `}

  @media (${theme.lg}) {
    animation: none;
  }
`
